import React from 'react';
import type { Profile } from '@interlucent/organization-protocol';
import { ProfileCard } from './ProfileCard';
import { mappingService } from '../../services/mappingService';
import { useStore } from '../../store';
import styles from './ProfileList.module.css';

interface ProfileListProps {
  projectId: string;
  profiles: Profile[];
  onEdit: (profile: Profile) => void;
  onDelete: (profileId: string, profileName: string) => void;
  onToggleStatus: (profileId: string, isActive: boolean) => void;
  onManageMappings: (profileId: string) => void;
}

export function ProfileList({
  projectId,
  profiles,
  onEdit,
  onDelete,
  onToggleStatus,
  onManageMappings
}: ProfileListProps) {
  const mappings = useStore(state => state.mappings);

  if (profiles.length === 0) {
    return (
      <div className={styles.empty}>
        <p className={styles.emptyText}>
          No deployment profiles yet. Create one to get started.
        </p>
      </div>
    );
  }

  return (
    <div className={styles.grid}>
      {profiles.map(profile => {
        const mappingCount = mappingService.getMappingCount(profile.id, mappings);

        return (
          <ProfileCard
            key={profile.id}
            profile={profile}
            projectId={projectId}
            mappingCount={mappingCount}
            onEdit={onEdit}
            onDelete={onDelete}
            onToggleStatus={onToggleStatus}
            onManageMappings={onManageMappings}
          />
        );
      })}
    </div>
  );
}
